export default __webpack_public_path__ + "static/media/cert-hkgcsmeaa.dce410d9.jpg";